import { useEffect, useRef, useState } from 'react';

export default function PhilosophySection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!('IntersectionObserver' in window)) {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative bg-white py-14 lg:py-18 px-8 md:px-12 lg:px-[8%] overflow-hidden"
    >
      <div className="max-w-2xl lg:ml-[5%] relative z-10">
        <div
          className={`transition-all duration-700 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-[clamp(1.8rem,3.5vw,2.6rem)] font-bold text-[#222222] leading-tight tracking-[-0.01em] mb-6">
            ¿Por qué hago esto? ✨
          </h2>
          <p className="text-[17px] lg:text-[18px] text-[#3A3A3A] leading-[1.8] font-light mb-4">
            Hay demasiadas cosas ahí fuera.
            Demasiadas promesas.
            Demasiados productos que no cumplen.
          </p>
          <p className="text-[17px] lg:text-[18px] text-[#3A3A3A] leading-[1.8] font-light">
            Yo prefiero recomendar solo lo que repetiría.
          </p>
        </div>
      </div>
    </section>
  );
}
